export default "__VITE_ASSET__b2b61d22__"